const tourSteps = [
  {
    target: '.action-cards',
    title: 'Pending Actions',
    content: 'These cards show items needing attention \u2014 unresolved match alerts, monitoring hits, and cases under review. Click any card to go directly to the relevant page.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-testid="nav-cases"]',
    title: 'Cases',
    content: 'All KYC/AML cases live here. Each case represents an individual or entity that needs screening and monitoring.',
    placement: 'right',
  },
  {
    target: '.new-case-button',
    title: 'Create a New Case',
    content: 'Click here to onboard a new investor or entity. The wizard guides you through entering details, auto-screening, risk scoring, and setting up media monitoring.',
    placement: 'bottom',
  },
  {
    target: '[data-testid="nav-monitoring"]',
    title: 'Monitoring',
    content: 'Your alert inbox. When the daily sync detects new matches for monitored cases, they appear here organised by severity.',
    placement: 'right',
  },
  {
    target: '[data-testid="nav-media-alerts"]',
    title: 'Media Alerts',
    content: 'Google Alerts for your cases, managed in one place. Set up alerts on individual cases and review incoming articles.',
    placement: 'right',
  },
  {
    target: '[data-testid="nav-data-sources"]',
    title: 'Data Sources',
    content: 'Radar screens against sanctions lists from OFAC, UN, EU, UK, and more \u2014 plus a global PEP database with 50,000+ profiles.',
    placement: 'right',
  },
  {
    target: '[data-testid="nav-reports"]',
    title: 'Reports',
    content: 'Generate professional PDF reports for regulators. Case reports, organisation summaries, and regulatory packs.',
    placement: 'right',
  },
  {
    target: '[data-testid="nav-audit-trail"]',
    title: 'Audit Trail',
    content: 'Every action is logged with timestamp, user identity, and before/after details. Immutable compliance evidence for regulatory inspection.',
    placement: 'right',
  },
];

export default tourSteps;
